/**
 * Small shared helpers used by both the Node and browser SDK bootstraps.
 */

/**
 * Races a promise against a timeout so SDK shutdown/flush can never hang the
 * host process (or the browser unload). On timeout it logs a warning and
 * resolves — the caller proceeds without confirmation rather than blocking.
 *
 * `setTimeout` is available in both Node and the browser, so this is safe in
 * either runtime.
 */
export function withTimeout(
    operation: Promise<unknown>,
    timeoutMs: number,
    label: string,
): Promise<void> {
    return Promise.race([
        Promise.resolve(operation).then(() => {}),
        new Promise<void>((resolve) => {
            setTimeout(() => {
                // eslint-disable-next-line no-console
                console.warn(
                    `[telemetry] ${label} timed out after ${timeoutMs}ms — proceeding without confirmation`,
                )
                resolve()
            }, timeoutMs)
        }),
    ])
}
